import { motion, AnimatePresence } from "framer-motion";
import { Crown } from "lucide-react";

// Animated Club Wars leaderboard. Rows reorder with a spring when ranks change;
// the team-points cell pulses whenever its value updates.
function PulseNum({ value, testid, accent }) {
  return (
    <motion.span
      key={value}
      data-testid={testid}
      initial={{ scale: 1.6, color: "var(--primary-ink)" }}
      animate={{ scale: 1, color: accent ? "var(--primary)" : "var(--text)" }}
      transition={{ duration: 0.55, ease: "easeOut" }}
      className="mono font-bold tabular-nums inline-block"
    >
      {value}
    </motion.span>
  );
}

export function CwStandings({ rows = [], variant = "compact" }) {
  const tv = variant === "tv";
  const rowPad = tv ? "px-5 py-4" : "px-4 py-3";
  const nameSize = tv ? "text-xl sm:text-2xl" : "text-sm";
  const grid = "grid grid-cols-[2.2rem_1fr_3rem_3.2rem_3rem] sm:grid-cols-[2.5rem_1fr_3.5rem_4rem_3.5rem] items-center gap-2 sm:gap-3";

  return (
    <div data-testid="cw-standings-list">
      <div className={`${grid} ${tv ? "px-5 py-2" : "px-4 py-2"} text-[10px] sm:text-xs uppercase tracking-wider`} style={{ color: "var(--text-2)" }}>
        <span>#</span><span>Team</span><span className="text-center">Pts</span><span className="text-center">Diff</span><span className="text-center">PPM</span>
      </div>
      <AnimatePresence initial={false}>
        {rows.map((r) => (
          <motion.div
            key={r.team_id}
            layout
            layoutId={r.team_id}
            transition={{ layout: { type: "spring", stiffness: 550, damping: 42 } }}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            data-testid={`cw-standing-row-${r.team_id}`}
            className={`${grid} ${rowPad} border-t`}
            style={{ borderColor: "var(--border)", background: r.rank === 1 ? "rgba(234,179,8,0.06)" : "transparent" }}
          >
            <span className="mono font-black text-primary-c flex items-center gap-1" data-testid={`cw-rank-${r.team_id}`}>
              {r.rank === 1 && <Crown className="w-3.5 h-3.5" style={{ color: "#eab308" }} />}{r.rank}
            </span>
            <span className={`font-bold truncate ${nameSize}`}>{r.name}</span>
            <span className="text-center"><PulseNum value={r.team_points} testid={`cw-pts-${r.team_id}`} accent /></span>
            <span className="text-center mono tabular-nums" style={{ color: "var(--text-2)" }} data-testid={`cw-diff-${r.team_id}`}>
              {r.differential > 0 ? `+${r.differential}` : r.differential}
            </span>
            <span className="text-center mono tabular-nums" style={{ color: "var(--text-2)" }} data-testid={`cw-ppm-${r.team_id}`}>{r.ppm}</span>
          </motion.div>
        ))}
      </AnimatePresence>
      {rows.length === 0 && <div className="px-4 py-8 text-center text-sm" style={{ color: "var(--text-2)" }}>No teams yet.</div>}
    </div>
  );
}
